import React from 'react';
import ReactDOM from 'react-dom/client';
import "./style.css";
import App from './App';
import { Provider } from 'react-redux';
import { store } from './redux/store'
import "./assets/bootstrap.min.css"
import "./assets/bootstrap-grid.min.css";
import './services/axios';
import { GoogleOAuthProvider } from "@react-oauth/google";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import 'intro.js/introjs.css';

const root = ReactDOM.createRoot(document.getElementById('root'));

const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_MICROSOFT_CLIENT_ID,
    authority: 'https://login.microsoftonline.com/common',
    redirectUri: "/", // Redirect URI for your app
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
};
const msalInstance = new PublicClientApplication(msalConfig);


root.render(
  <Provider store={store}>
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    </GoogleOAuthProvider>
  </Provider>
);
